import React from 'react';
import Header from './components/Header';
import Faq from './components/Faq';
import HowWorks from './components/HowWorks';
import Support from'./components/Support';
import UserValidation from './components/UserValidation';
import Form from './components/Form'
// en
import ENFaq from './components/en/Faq'
import ENForm from './components/en/Form'
import ENSupport from './components/Support'
import ENHowWorks from './components/en/HowWorks'

import './App.css';
import './fonts.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'semantic-ui-css/semantic.min.css';
import {BrowserRouter, Route} from 'react-router-dom'

function App() {
  
  return (
    <BrowserRouter basename={'/help'}>
      <div className="App">
        

          <Route exact path="/"component={Faq}/>
          <Route exact path="/HowWorks"component={HowWorks}/>
          <Route exact path="/Faq" component={Faq}/>
          <Route exact path="/Support" component={Form}/>
          <Route exact path="/EN"component={ENFaq}/>
          <Route exact path="/EN/HowWorks"component={ENHowWorks}/>
          <Route exact path="/EN/Faq" component={ENFaq}/>
          <Route exact path="/EN/Support" component={ENForm}/>

        
      </div>
    </BrowserRouter>
  );
}

export default App;
